import { Spinner } from '../spinner';

interface Props {
	className?: string;
	label?: string;
}

export const LoaderScreen: React.FC<Props> = ({ className, label }) => {
	return (
		<div
			className={`h-full w-full flex flex-col items-center justify-center ${className}`}
		>
			<Spinner className="w-8 h-8" />
			<span>{label || 'Loading...'}</span>
		</div>
	);
};
